import { OfferBuilder } from "./OfferBuilder";
import { IncentiveBuilder } from "./IncentiveBuilder";
import { FsiRetailerSelector } from "./FsiRetailerSelector";
import useAdBlockStore from "store/AdBlockStore";
import { useDataStore } from "store/DataStore";

export const OfferIncentiveBuilder = () => {
  const offers = useAdBlockStore((state) => state.offers);
  const incentives = useAdBlockStore((state) => state.incentives);
  const offerTypes = useDataStore.getState().offerTypes || [];
  const currentItemType = useAdBlockStore((state) => state.currentItemType);
  const parentRetailerName = useAdBlockStore((state) => state.parentRetailerName);
  const fsiRetailerIds = useAdBlockStore((state) => state.fsi_retailer_i);
  console.log("Current Offer:",  currentItemType);

  if (offerTypes.length === 0) {
    useDataStore.getState().fetchOfferTypes();
  }

  if (!offers.length > 0 && !incentives.length > 0) {
    return <div>No offers or incentives available</div>;
  }

  return (
    <>
      {currentItemType === "offer" && (
        <OfferBuilder
          offerTypes={offerTypes}
        />
      )}
      {currentItemType === "incentive" && (
        <IncentiveBuilder
        />
      )}
      {parentRetailerName === "FSI" && (
        <FsiRetailerSelector
          fsiRetailerIds={fsiRetailerIds}
        />
      )}
      
    </>
  )
}